import type { CatalogProps } from '../index';
import { BuyLink, Quote, TplFooter, TplRoot, money, splitProducts } from '../shared';
import { isSectionVisible } from '../sections';

/** Portal Notícia VSL — manchete investigativa, tarja vermelha, player VSL, provas. Urgência máxima. */
export default function Catalog({ data }: CatalogProps) {
  const { store, products } = data;
  const { feature, grid } = splitProducts(store, products);
  const offer = feature ?? grid[0] ?? null;

  return (
    <TplRoot>
      <header className="max-w-4xl mx-auto px-4 py-3 flex items-center justify-between border-b border-white/10">
        <a href="/" className="flex items-center gap-2">
          <span className="bg-error text-black font-black px-1.5 rounded text-sm">N1</span>
          <span className="font-bold tracking-tight uppercase text-sm">{store.name} · Mercado</span>
        </a>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-8 flex flex-col gap-6">
        <span className="text-[11px] uppercase tracking-widest text-error font-bold">Análise especial</span>
        <h1 className="text-3xl md:text-4xl font-black leading-[1.15] tracking-tight">
          {store.tagline ?? `O método que ${store.name} usa para vender no automático`}
        </h1>
        <p className="text-white/70 leading-relaxed">
          Um sistema direto de checkout, sem intermediários, pensado pra quem quer vender online sem complicação.
        </p>

        {/* VSL */}
        <div className="rounded-lg overflow-hidden border border-white/10 bg-black">
          <div className="aspect-video bg-gradient-to-br from-error/10 via-white/[0.03] to-transparent flex items-center justify-center relative">
            <span className="w-16 h-16 rounded-full bg-secondary text-black flex items-center justify-center">
              <span className="material-symbols-outlined text-3xl">play_arrow</span>
            </span>
            <span className="absolute top-3 left-3 text-[10px] font-bold text-white/50">APRESENTAÇÃO</span>
          </div>
        </div>

        {offer ? (
          <div className="rounded-xl border border-secondary/30 bg-secondary/5 p-6 text-center flex flex-col gap-3">
            <span className="text-[11px] uppercase tracking-widest text-secondary font-bold">Oferta</span>
            <h2 className="text-2xl font-black">{offer.name}</h2>
            {offer.description ? <p className="text-sm text-white/60">{offer.description}</p> : null}
            <div className="text-3xl font-black">{money(offer.amount)}</div>
            <BuyLink href={`/p/${offer.slug}`} block className="text-base uppercase">
              Sim, eu quero
            </BuyLink>
            <span className="text-xs text-white/50">Compra criptografada · entrega imediata</span>
          </div>
        ) : null}

        {isSectionVisible(store, 'quote') && store.testimonialQuote ? (
          <div className="rounded-xl border border-white/10 bg-white/[0.03] p-6">
            <Quote store={store} />
          </div>
        ) : null}
      </main>

      <TplFooter store={store} />
    </TplRoot>
  );
}
